// Import React and Hooks
import React from 'react'
// Import Components
import FloatImg from '../ui/FloatImg'


// Background Props
interface backgroundSideProp {
  type?:string,
  additionalClass?:string
}

const BackgroundSide = ( { type, additionalClass }:backgroundSideProp ) => {



  // Functions
  function renderBgSide( type?:string ) {
    switch (type) {
      case 'square':
        return <>
          <FloatImg
            additionalClass="flowerBgS1"
            alt="Flor"
            speed={ 0.008 }
            revert={ true }
            src={`${window.assetsURl}/imgs/shapes/flor-new.png`} />
          <FloatImg
            additionalClass="petalBgS1"
            alt="Pétalo de flor"
            speed={ 0.011 }
            src={`${window.assetsURl}/imgs/petals/petal-4.svg`} />
          <FloatImg
            additionalClass="petalBgS2"
            alt="Pétalo de flor"
            speed={ 0.013 }
            revert={ true }
            src={`${window.assetsURl}/imgs/petals/petal-2.svg`} />
        </>
      default:
        return <>
          <FloatImg
            additionalClass="flowerBg1"
            alt="Flor"
            speed={ 0.009 }
            revert={ true }
            src={`${window.assetsURl}/imgs/shapes/flor-4.png`} />
          <FloatImg
            additionalClass="petalBg2"
            alt="Pétalo de flor"
            speed={ 0.011 }
            src={`${window.assetsURl}/imgs/shapes/flormorada-a.png`} />
          <FloatImg
            additionalClass="leafBg1"
            alt="Pétalo de flor"
            speed={ 0.013 }
            src={`${window.assetsURl}/imgs/shapes/flor+5.png`} />
          
        </>
    }
  }



  additionalClass += ` ${type ? type : ''}`

  return (
    <article className={`background__side ${ additionalClass ? additionalClass : ''}`} >
      { renderBgSide( type ) }
    </article>
  )
}



export default BackgroundSide
